import '..//..//..//mixins.js'
import spinner from "../../LoadingComponent/LoadingComponent.vue"

export default {
  name: 'box-small',
  components: {spinner},
  props: {"stockInfoData": null},
  data () {
    return {
      isin:this.$route.params.ISIN,
      showSpinner: true,
      selected:'',
      benchmarks: [],
      securityType: null,
      stockInfo: [],
      exchanges: [],
      competitors: [],
      images: [],
      rowDataIsEmpty: true
    }
  },
  computed: {

  },
  async created () {
    //await this.loadData()
  },
  mounted () {
    this.loadData()
    
  },
  methods: {
  loadData: function() {
    this.stockInfo = this.stockInfoData['profile'];
    this.securityType = this.stockInfo['security_type']
    this.exchanges = this.stockInfoData['available_exchanges']
    this.competitors = this.stockInfoData['similar_securities']
    this.setImages()
    if(this.securityType == "security"){
      this.displayCompetitors();
    }
    else{
      this.displayProfile();
    }
    
  },
  getImgUrl(broker) {
    var images = require.context('../../../assets/', false, /\.png$/)
    return images('./' + broker + "_icon.png")
  },
  setImages: function() {
    var broker_urls = this.stockInfoData["broker_urls"]
    this.images = []
    var broker_info;
    for (var i = 0; i < broker_urls.length; i++) {
        broker_info = broker_urls[i]
        broker_info["image_url"] = this.getImgUrl(broker_info["broker"])
        this.images.push(broker_info)
  }},

  navigateToBroker: function(url) {
    console.log("external url")
    window.open(url, '_blank');
},
  displayProfile: function() {
    this.buttonActivation("nav-bar-stock-info", "btnStockInfo");
    document.getElementById("tableProfile").style.display = "table";
    document.getElementById("map-div").style.display = "none";
    document.getElementById("competitor-div").style.display = "none";
    
},
  displayCompetitors: function() {
    if(this.competitors.length > 0){
      this.rowDataIsEmpty = false;
    }else{
      this.rowDataIsEmpty = true;
    }
    this.buttonActivation("nav-bar-stock-info", "btnStockInfo");
    document.getElementById("tableProfile").style.display = "none";
    document.getElementById("map-div").style.display = "none";
    document.getElementById("competitor-div").style.display = "flex";
    
  },
  }

  }


